export var utils = {
  str2Json: function str2Json(jsonStr) {
    var json = {};

    if (Object.prototype.toString.call(jsonStr) === "[object String]") {
      try {
        json = JSON.parse(jsonStr);
      } catch (ex) {
        json = {};
      }
    }

    return json;
  },
  json2Str: function json2Str(json) {
    var jsonStr = "";

    if (typeof json !== "string") {
      try {
        jsonStr = JSON.stringify(json);
      } catch (e) {
        jsonStr = "";
      }
    }

    return jsonStr;
  },

  /**
   * 格式化数据,覆盖,1层递归
   * 
   * @param { Object } osrc，格式数据
  * @param { Object } src， 数据
   */
  _extend: function _extend(osrc, src) {
    if (src) {
      for (var property in osrc) {
        if (!src.hasOwnProperty(property)) {
          src[property] = osrc[property];
        }
      }
    }

    return src;
  },

  /**
   * 链接格式
   */
  formatURL: {
    "browser": "",
    "url": ""
  },

  /**
   * 歌曲格式数据
   */
  formatSong: {
    "filename": "",
    "filesize": "",
    "hash": "",
    "bitrate": "",
    "extname": "",
    "duration": "",
    "mvhash": "",
    "m4afilesize": "",
    "320hash": "",
    "320filesize": "",
    "sqhash": "",
    "sqfilesize": 0,
    "feetype": 0,
    "isfirst": 0
  },

  /**
   * MV格式数据
   */
  formatMV: {
    "filename": "",
    "singername": "",
    "hash": "",
    "imgurl": ""
  },

  /*分享数据*/
  formatShare: {
    "shareName": "",
    "topicName": "",
    "hash": "",
    "listID": "",
    "type": "",
    "suid": "",
    "slid": "",
    "imgUrl": "",
    "filename": "",
    "duration": "",
    "shareData": {
      "linkUrl": "",
      "picUrl": "",
      "content": "",
      "title": ""
    }
  },

  /**
   * 生成随机函数，次数
   */
  cbNum: 0,

  /**
   * 是否在 iOS 客户端内
   */
  isIOS: navigator.userAgent.match(/KGBrowser/gi) ? true : false,

  /**
   * 是否是 android 新通讯模式
   */
  isKugouAndroid: navigator.userAgent.match(/kugouandroid/gi) ? true : false,

  /**
   * 是否是 android 旧通讯模式
   */
  isAndroid: typeof external == 'undefined' ? false : typeof external.superCall == 'undefined' ? false : true,
  loadUrl: function loadUrl(url) {
    var iFrame = document.createElement("iframe");
    iFrame.setAttribute("src", url);
    iFrame.setAttribute("style", "display:none;");
    iFrame.setAttribute("height", "0px");
    iFrame.setAttribute("width", "0px");
    iFrame.setAttribute("frameborder", "0");
    document.body.appendChild(iFrame);
    iFrame.parentNode.removeChild(iFrame);
    iFrame = null;
  },

  /**
   * 执行不返回数据的调用
   * 
   * @param { Object } options
   * options.cmd: Number 命令号
   * options.jsonStr: String 参数
   * options.callback: Function 回调函数
   * options.AndroidCallback
   */
  callCmd: function callCmd(options) {
    var me = utils;

    if (me.isKugouAndroid) {
      var androidObj = {};
      var cbName = "";

      if (options.cmd) {
        androidObj.cmd = options.cmd;
      }

      if (options.jsonStr) {
        androidObj.jsonStr = options.jsonStr;
      }

      if (options.callback) {
        me.cbNum++;
        cbName = "kgandroidmobilecall" + me.cbNum + Math.random().toString().substr(2, 9); // 创建随机函数

        window[cbName] = function (res, encodeParam) {
          if (typeof res != "undefined") {
            if (Object.prototype.toString.call(res) === '[object String]') {
              if (encodeParam === "#") {
                res = decodeURIComponent(res);
              } else {
                res = decodeURIComponent(decodeURIComponent(res));
              }

              options.callback(me.str2Json(res));
            } else {
              options.callback(res);
            }
          }
        };
      }

      if (options.AndroidCallback) {
        var json = me.str2Json(options.jsonStr);
        json.AndroidCallback = cbName;
        options.jsonStr = me.json2Str(json);

        if (o.jsonStr) {
          androidObj.jsonStr = o.jsonStr;
        }
      }

      var androidString = encodeURIComponent(JSON.stringify(androidObj));
      var androidApi = "kugoujsbridge://start.kugou_jsbridge/?".concat(androidString);
      me.loadUrl(androidApi);
    } else if (me.isAndroid) {
      var res = "";
      var _cbName = "";

      if (options.jsonStr) {
        if (options.callback && options.callback !== '' && options.AndroidCallback === true) {
          me.cbNum++;
          _cbName = "kgmobilecall" + me.cbNum + Math.random().toString().substr(2, 9); // 创建随机函数

          window[_cbName] = function (r, encodeParam) {
            if (typeof r != "undefined") {
              if (Object.prototype.toString.call(r) === '[object String]') {
                if (encodeParam === "#") {
                  r = decodeURIComponent(r);
                } else {
                  r = decodeURIComponent(decodeURIComponent(r));
                }

                options.callback(me.str2Json(r));
              } else {
                options.callback(r);
              }
            }
          };

          var _json = me.str2Json(options.jsonStr);

          _json.AndroidCallback = _cbName;
          options.jsonStr = me.json2Str(_json);
        }

        try {
          res = external.superCall(options.cmd, options.jsonStr);
        } catch (error) {}
      } else {
        try {
          res = external.superCall(options.cmd);
        } catch (error) {}
      }

      if (options.callback && options.callback !== '' && res != "AndroidCallback") {
        res = me.str2Json(res);
        options.callback(res);
      }
    } else if (me.isIOS) {
      var iosApi = "";
      var _cbName2 = "";

      if (options.callback) {
        me.cbNum++;
        _cbName2 = "kgmobilecall" + me.cbNum + Math.random().toString().substr(2, 9); // 创建随机函数

        window[_cbName2] = function (res) {
          if (typeof res != 'undefined') {
            if (options.callback) {
              if (Object.prototype.toString.call(res) === '[object String]') {
                options.callback(me.str2Json(res));
              } else {
                options.callback(res);
              }
            }
          }
        };
      } // 有 callback 有 jsonStr


      if (_cbName2 && _cbName2 != "" && options.jsonStr) {
        iosApi = 'kugouurl://start.music/?{"cmd":' + options.cmd + ', "jsonStr":' + options.jsonStr + ', "callback":"' + _cbName2 + '"}';
      } // 有 callback 没有 jsonStr


      if (_cbName2 && _cbName2 != "" && !options.jsonStr) {
        iosApi = 'kugouurl://start.music/?{"cmd":' + options.cmd + ', "callback":"' + _cbName2 + '"}';
      } // 没有 callback 有 jsonStr


      if (_cbName2 == "" && options.jsonStr) {
        iosApi = 'kugouurl://start.music/?{"cmd":' + options.cmd + ', "jsonStr":' + options.jsonStr + '}';
      } // 没有 callback 没有 jsonStr


      if (_cbName2 == "" && !options.jsonStr) {
        iosApi = 'kugouurl://start.music/?{"cmd":' + options.cmd + '}';
      }

      me.loadUrl(iosApi);
    } else {
      if (options && options.callback) {
        var result = {
          "status": 0,
          "error": "不在客户端内"
        };
        options.callback(result);
      }
    }
  },

  /**
   * 数据格式化
   */
  formartData: function formartData(cmd, json) {
    if (cmd && cmd == 123) {
      // openURL
      if (json) {
        json = utils._extend(utils.formatURL, json);
      }
    }

    if (cmd && cmd == 123) {
      // openURL
      if (json) {
        json = utils._extend(utils.formatURL, json);
      }
    }
  }
};